import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold" }, "Tìm kiếm", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "d-flex align-items-center justify-content-end mb-0" }, [
  /*#__PURE__*/_createElementVNode("strong", null, " Đơn giá ")
], -1)
const _hoisted_3 = { class: "d-flex align-items-center justify-content-end mb-0" }
const _hoisted_4 = { class: "row mt-2" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "col-11" }, null, -1)
const _hoisted_6 = { class: "col-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DivCol = _resolveComponent("DivCol")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_DivRow = _resolveComponent("DivRow")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_ButtonCustom = _resolveComponent("ButtonCustom")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _ctx.isOpen,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.isOpen) = $event)),
    width: "80%",
    title: _ctx.labelDisplay,
    onClose: _ctx.onClose
  }, {
    default: _withCtx(() => [
      _createVNode(_component_DivRow, { "additional-class": "mb-2" }, {
        default: _withCtx(() => [
          _createVNode(_component_DivCol, { cols: 9 }, {
            default: _withCtx(() => [
              _createVNode(_component_DivRow, null, {
                default: _withCtx(() => [
                  _createVNode(_component_DivCol, {
                    cols: 1,
                    additionalClass: "d-flex align-items-center"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_1
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_DivCol, { cols: 3 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.searchTerm,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchTerm) = $event)),
                        placeholder: "tìm theo mã hoặc tên",
                        onInput: _ctx.searchForVatTu
                      }, null, 8, ["modelValue", "onInput"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_table, {
        style: {"width":"100%"},
        "max-height": "550",
        "empty-text": "Đang hiển thị danh sách vật tư",
        size: "small",
        "cell-style": {padding: '0', height: '15px'},
        "cell-class-name": _ctx.isTextDangerColumn,
        border: true,
        data: _ctx.vatTuItems,
        onRowClick: _ctx.onRowClick
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, { width: "55" }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_checkbox, {
                modelValue: _ctx.selectedVatTuIdArr[scope.$index],
                "onUpdate:modelValue": ($event: any) => ((_ctx.selectedVatTuIdArr[scope.$index]) = $event)
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "ID",
            width: "50"
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(scope.row.id), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, { label: "Tên" }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(scope.row.ten_vat_tu), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, { label: "Mã" }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(scope.row.ma_vat_tu), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, { label: "Thu hồi" }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_checkbox, {
                modelValue: _ctx.vatTuItems[scope.$index].thu_hoi,
                "onUpdate:modelValue": ($event: any) => ((_ctx.vatTuItems[scope.$index].thu_hoi) = $event),
                disabled: ""
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, { label: "C/ty duyệt" }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_checkbox, {
                modelValue: _ctx.vatTuItems[scope.$index].cong_ty_duyet,
                "onUpdate:modelValue": ($event: any) => ((_ctx.vatTuItems[scope.$index].cong_ty_duyet) = $event),
                disabled: ""
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "Trạng thái",
            width: "90"
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(_ctx.isValidLabel(scope.row)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, null, {
            header: _withCtx(() => [
              _hoisted_2
            ]),
            default: _withCtx((scope) => [
              _createElementVNode("p", _hoisted_3, [
                _createElementVNode("strong", null, _toDisplayString(_ctx.formatCurrencyAndQuantity(scope.row.don_gia)), 1)
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, { label: "Đơn vị tính" }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(scope.row.don_vi_tinh), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["cell-class-name", "data", "onRowClick"]),
      (_ctx.vatTuItems.length > 0)
        ? (_openBlock(), _createBlock(_component_Pagination, {
            key: 0,
            page: _ctx.currentPage,
            "page-size": 20,
            total: _ctx.totalItems,
            onChangePage: _cache[1] || (_cache[1] = (value) => _ctx.currentPage = value)
          }, null, 8, ["page", "total"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_ButtonCustom, {
            "button-type": _ctx.ButtonsType.SAVE,
            "color-type": _ctx.ButtonTypeColors.SUCCESS,
            onClick: _ctx.submit
          }, null, 8, ["button-type", "color-type", "onClick"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "title", "onClose"]))
}